import type { Resume } from "@adafia/types";
import { Award, Trash2 } from "lucide-react";
import { InputGroup } from "./InputGroup";
import { SectionHeader } from "./SectionHeader";

interface CertificationEditorProps {
	certifications: Resume["certifications"];
	onAdd: () => void;
	onUpdate: (id: string, field: string, value: string) => void;
	onRemove: (id: string) => void;
}

export function CertificationEditor({
	certifications,
	onAdd,
	onUpdate,
	onRemove,
}: CertificationEditorProps) {
	return (
		<>
			<SectionHeader title="Certifications" icon={Award} onAdd={onAdd} />
			<div>
				{(certifications || []).map((cert) => (
					<div key={cert.id} className="card-edit">
						<button
							title="Remove Certification"
							type="button"
							onClick={() => onRemove(cert.id)}
							className="btn-delete"
						>
							<Trash2 size={16} />
						</button>
						<InputGroup
							label="Certification Name"
							value={cert.name}
							onChange={(v) => onUpdate(cert.id, "name", v)}
						/>
						<div className="form-grid">
							<InputGroup
								label="Issuer"
								value={cert.issuer}
								onChange={(v) => onUpdate(cert.id, "issuer", v)}
							/>
							<InputGroup
								label="Year"
								value={cert.year}
								onChange={(v) => onUpdate(cert.id, "year", v)}
							/>
						</div>
					</div>
				))}
			</div>
		</>
	);
}
